"use client";

import React, { type ReactElement } from "react";
import {
  HomeSectionHero,
  HomeSectionFeatured,
  HomeSectionTheme,
  HomeSectionOverview,
  HomeSectionTeaser,
} from "@/components";

function HomeMain(): ReactElement {
  return (
    <>
      <HomeSectionHero />
      <HomeSectionOverview />
      <HomeSectionTheme />
      <HomeSectionFeatured />
      <HomeSectionTeaser />
    </>
  );
}

export { HomeMain };
